import React, { useRef, Ref } from "react";
import Nav from "../Nav";
import { useNavigate, Link } from "react-router-dom";
import Logout from "../logout/Logout";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import Closetrade from "./Closetrade";
import Paindingtrade from "./Paindingtrade";
import Activetrade from "./Activetrade";
import Cancleorder from "./Cancleorder";
import { baseUrl } from "../constant.js";
import Logoutmodule from "../logout/Logoutmodule";
import Theme from "../Theme";
import Cancleallpainding from "../trades/cancleallpainding";
const Trades = () => {
  const [comp, setComp] = useState();
  const [data, setData] = useState("");
  console.log(data);
  const history = useNavigate();
  useEffect(() => {
    const auth = localStorage.getItem("token");

    if (auth) {
    } else {
      history("/login");
    }
    Tradestarus(1, 1);
  }, []);

  const Tradestarus = async (val, status) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", token);
    formData.append("status", status);

    const result = await axios.post(
      baseUrl + `authController/getTradeList`,
      formData,
    );

    const reault1 = result.data;

    console.log(result);
    if ((await result.data.is_login) === 0) {
      localStorage.removeItem("Name");
      localStorage.removeItem("userCode");
      localStorage.removeItem("token");
      history("/login");
    }
    setData(reault1.data);
    setComp(val);
  };

  return (
    <section className="marketwatch_pg online_trade_view">
      <div className="list_market_row text-center">
        <div className="onine_view_col">
          <div className="phone_frame">
            <div className="frame_screen">
              <div className="screen_body main_screenUI">
                <div className="dashboard_main">
                  <div className="dashboard_header">
                    <Logoutmodule />
                    <div>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#color_modal"
                      >
                        <img
                          src="assets/img/icons/colour.png"
                          className="img-fluid color_icons"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="dashboard_col">
                    <div className="dashboard_tabs_colm">
                      <ul
                        className="dashboard_col_nav nav nav-tabs"
                        role="tablist"
                      >
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            href="#"
                            id="pending"
                            data-bs-toggle="tab"
                            data-bs-target="#pending-tab"
                            type="button"
                            role="tab"
                            aria-controls="pending-tab"
                            aria-selected="true"
                            onClick={() => Tradestarus(1, 1)}
                            style={{ color: "#9b840af7" }}
                          >
                            Pending
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            href="#"
                            id="active"
                            data-bs-toggle="tab"
                            data-bs-target="#active-tabs"
                            type="button"
                            role="tab"
                            aria-controls="active-tabs"
                            aria-selected="true"
                            onClick={() => Tradestarus(2, 2)}
                            style={{ color: "#0dcaf0" }}
                          >
                            Active
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="closed"
                            data-bs-toggle="tab"
                            data-bs-target="#closed-tabs"
                            type="button"
                            role="tab"
                            aria-controls="closed-tabs"
                            aria-selected="true"
                            onClick={() => Tradestarus(3, 3)}
                            style={{ color: "red" }}
                          >
                            Closed
                          </a>
                        </li>
                      </ul>{" "}
                    </div>
                    {/* <Cancleorder orderid={data.orderID} /> */}
                    <div
                      className="tab-content dashboard_col_tabs trade_dashbord"
                      style={{ height: "480px" }}
                    >
                      <div className="tab_search_body">
                        <div
                          className="tab-pane fade show active"
                          id="pending-tab"
                          role="tabpanel"
                          aria-labelledby="pending"
                        >
                          <div style={{ textAlign: "center" }}>
                            {comp === 1 && <Cancleallpainding />}
                          </div>
                          {comp === 1 &&
                            data.map((item) => (
                              <Paindingtrade
                                name={item.category_name}
                                expary={item.expire_date}
                                ordertimrdate={item.orderDateTime}
                                bidtype={item.bid_type}
                                holdingmargin={item.holdingMargin}
                                marginused={item.intradayMargin}
                                bid={item.bid_price}
                                lot={item.lot}
                                profit={item.total_profit}
                                brokrage={item.brokerage}
                                orderid={item.orderID}
                                closeordertype={item.close_order_type}
                                status={item.status}
                                ordertype1={item.order_type}
                                catid={item.category_id}
                              />
                            ))}
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="active-tabs"
                        role="tabpanel"
                        aria-labelledby="active"
                      >
                        <div className="tab_search_body">
                          <div style={{ textAlign: "center" }}>
                            {comp === 2 && (
                              <Cancleorder
                                orderid={data.orderID}
                                Tradestarus={Tradestarus}
                              />
                            )}
                          </div>
                          {comp === 2 &&
                            data.map((item) => (
                              <Activetrade
                                name={item.category_name}
                                expary={item.expire_date}
                                ordertimrdate={item.orderDateTime}
                                bidtype={item.bid_type}
                                holdingmargin={item.holdingMargin}
                                marginused={item.intradayMargin}
                                bid={item.bid_price}
                                lot={item.lot}
                                profit={item.total_profit}
                                brokrage={item.brokerage}
                                orderid={item.orderID}
                                closeordertype={item.close_order_type}
                                ordertype1={item.order_type}
                                clickfun={Tradestarus}
                                dataOrderid={data.orderID}
                                Tradestarus={Tradestarus}
                                catid={item.category_id}
                              />
                            ))}
                        </div>
                      </div>
                      <div
                        className="tab-pane fade show"
                        id="closed-tabs"
                        role="tabpanel"
                        aria-labelledby="closed"
                      >
                        <div className="tab_search_body">
                          {comp === 3 &&
                            data.map((item) => (
                              <Closetrade
                                name={item.category_name}
                                expary={item.expire_date}
                                ordertimrdate={item.orderDateTime}
                                bidtype={item.bid_type}
                                holdingmargin={item.holdingMargin}
                                marginused={item.intradayMargin}
                                bid={item.bid_price}
                                lot={item.lot}
                                profit={item.total_profit}
                                brokrage={item.brokerage}
                                sellprice={item.sell_price}
                                orderDatetime={item.orderDateTime}
                                orderupdatetime={item.orderUpdateDateTime}
                                orderid={item.orderID}
                                closeordertype={item.close_order_type}
                                ordertype1={item.order_type}
                              />
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Theme />
                  <Nav />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trades;
